import { createFeatureServices } from './create';
export function defineFeatureServices(bundle, args, logger, ignoreServiceIds = []) {
    return createFeatureServices(bundle, args, logger, ignoreServiceIds);
}
//# sourceMappingURL=define.js.map